import { RESET_TERMS_FORM } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default () => companyGeneralActions[RESET_TERMS_FORM]();
